import { CircularProgress, IconButton, Popover, Tooltip } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaHistory } from "react-icons/fa";
import ApiClient from "utils/ApiClient";
import styled from "styled-components";
import HistoryTable from "./HistoryTable"

const HistoryPopup = (props) => {
  return (
    <div className="histroyPopper">
      <History data={props.data} />
    </div>
  );
};

const History = (props) => {
  const handlerClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const closePopper = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Tooltip title="View Record History">
        <IconButton size="small">
          <FaHistory className="simple-popover" style={{ margin: "5px" }} onClick={handlerClick} />
        </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={closePopper}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <HistoryTable data={props.data} closePopper={closePopper} />
        {/* <HistoryPopover data={props.data} closePopper={closePopper} /> */}
      </Popover>
    </div>
  );
};

const HistoryPopover = (props) => {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const fetchLogs = async () => {
    setIsLoading(true);
    try {
      let row_id = props.data.data.row_id;
      let list_id = props.data.listId;
      let parent_row_id = "";
      let columnId = "";
      let isSubsheet = 0;
      if (props.data.isSubsheet) {
        list_id = props?.data?.context?.props?.parentListId;
        parent_row_id = props?.data?.context?.props?.rowId;
        columnId = props?.data?.context?.props?.columnId;
        isSubsheet = 1;
      }
      const resp = await ApiClient.List.getLogs({
        row_id: row_id,
        list_id: list_id,
        parent_row_id: parent_row_id,
        column_id: columnId,
        isSubsheet: isSubsheet,
      });
      if (resp.success) {
        setLogs(resp.formattedLogs);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <PopperWrapper>
      <PopperHeader>
        <div>History</div>
        <IconButton onClick={props.closePopper}>
          <Close />
        </IconButton>
      </PopperHeader>
      <PopperContent>
        {isLoading ? (
          <PopperLoading>
            <CircularProgress />
          </PopperLoading>
        ) : logs && logs.length > 0 ? (
          logs.map((el) => (
            <div key={el.id}>
              <LogCard data={el} />
            </div>
          ))
        ) : (
          <PopperMessage>No logs found</PopperMessage>
        )}
      </PopperContent>
    </PopperWrapper>
  );
};

const LogCard = (props) => {
  let log = props.data;
  return (
    <LogContainer>
      <LogHeader>
        <div>
          <strong>{log["Operation"]}</strong> by
          <span style={{ color: "blue" }}> {log["Created By"]}</span>
        </div>
        <div>
          <span style={{ fontSize: ".7rem" }}>
            {" "}
            {moment(log["CreatedAt"]).format("DD-MMM-YY HH:mm a")}
          </span>
        </div>
      </LogHeader>
      {String(log["ColumnNames"]).length > 0 && (
        <div>Column Names = {log["ColumnNames"]}</div>
      )}
      {log["Operation"] !== "add_row" && (
        <>
          <div>Previous Data:</div>
          <LogData dangerouslySetInnerHTML={{ __html: log["PreviousData"] }} />
        </>
      )}
      <div>Data:</div>
      <LogData dangerouslySetInnerHTML={{ __html: log["CurrentData"] }} />
    </LogContainer>
  );
};

export default HistoryPopup;


const PopperWrapper = styled.div`
  max-height: 65vh;
  min-width: 400px;
  max-width: 500px;
  border-radius: 10px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const PopperHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 20px;
`;

const PopperContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  min-height: 55vh;
  max-height: 60vh;
`;

const PopperLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  margin: 5px;
`;

const PopperMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
`;

const LogContainer = styled.div`
  margin: 4px 5px;
  padding: 5px;
  border: 2px solid #ebebeb;
  border-radius: 5px;
`;

const LogHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: 0.95rem;
`;

const LogData = styled.div`
  white-space: pre-line;
  margin-left: 10px;
  word-wrap: break-word;
`;